import { useCallTracking } from "../hooks";
export const useCallTrackingPhoneNumbers = () => {
    const { numberMappings } = useCallTracking();
    const virtualPhoneNumbers = (numberMappings === null || numberMappings === void 0 ? void 0 : numberMappings.length) > 0
        ? numberMappings.map((value) => value.virtualPhoneNumber || value.realPhoneNumber)
        : null;
    return virtualPhoneNumbers;
};
